import { GtmEvent, SearchKeywordSource, SearchEventSource } from '@/types/gtm'
import { SearchType } from '@/types/search'

interface FireSearchQuerySentOptions {
  keyword: string
  isEnter?: boolean
  type?: SearchType
}

export function useGtmSearchQuerySent() {
  const nuxtApp = useNuxtApp()
  const route = useRoute()
  const { categoryName } = useCategory()

  const keywordSource = ref<SearchKeywordSource | ''>('')

  const routeName = computed(() => route.name?.toString() || '')

  function getSource(): SearchEventSource | null {
    if (checkIfCategoriesPage(routeName.value) || checkIfThemesPage(routeName.value)) {
      return SearchEventSource.CATEGORY_LIST
    }
    if (checkIfTagsPage(routeName.value)) {
      return SearchEventSource.TAG_LIST
    }
    if (checkIfIndexPage(routeName.value)) {
      return SearchEventSource.HOME
    }
    return null
  }

  function getSourceId(source: SearchEventSource | null): string {
    if (source === SearchEventSource.CATEGORY_LIST) {
      const id = (route.params.cid ?? route.params.tid) as string
      return id || ''
    }
    if (source === SearchEventSource.TAG_LIST) {
      return (route.params.tagId as string) || ''
    }
    return ''
  }

  function buildEventData(options: FireSearchQuerySentOptions): Record<string, unknown> {
    const { keyword, isEnter = false, type = SearchType.KEYWORD } = options
    const source = getSource()
    const sourceId = getSourceId(source)
    const sourceName = categoryName.value || ''

    return {
      event: GtmEvent.SEARCH_QUERY_SENT,
      payload: {
        keyword,
        hotKeyword: keywordSource.value === SearchKeywordSource.POPULAR,
        searchHistory: keywordSource.value === SearchKeywordSource.HISTORY,
        enter: isEnter,
        type,
        ...(source && { source }),
        ...(sourceId && { sourceId }),
        ...(sourceName && { sourceName }),
      },
    }
  }

  function fireSearchQuerySentEvent(options: FireSearchQuerySentOptions) {
    // PM: 清除搜尋框後的搜尋不送事件
    if (!options.keyword) {
      return
    }

    nuxtApp.$trackEvent(buildEventData(options))
    keywordSource.value = ''
  }

  return { keywordSource, fireSearchQuerySentEvent }
}
